module.exports = __webpack_public_path__ + "media/svg/bz-eb84141d.svg";